export default __webpack_public_path__ + "static/media/loop.15515f06.png";